import { IconProps } from "./";
import Icon from "./assets/chat_message_24.svg";
import { BaseIcon } from "./BaseIcon";

export function Icon24ChatMessageText(props: IconProps) {
  return <BaseIcon icon={<Icon />} {...props} />;
}
